import React, { FC } from 'react';
import { TypeDiscountsFields } from '@/core/generated-types';
import { UniversalCta } from '../UniversalCta';

const Discounts: FC<TypeDiscountsFields> = ({
  backgroundColor,
  title,
  discounts = [],
}) => {
  return (
    <div
      className={`bg-${backgroundColor?.fields?.color} px-8 pb-8 pt-8 md:pb-20 md:pt-14`}
      data-testid="discount"
    >
      <div className="mx-auto max-w-screen-xl">
        <div
          className="text-center text-[32px] font-bold leading-[40px] md:text-[42px] md:leading-[56px]"
          data-testid="title"
        >
          {title}
        </div>
        <div className="mt-10 flex flex-col items-start space-y-16 md:flex-row lg:space-y-0">
          {discounts.map((discount) => {
            return (
              <div
                className="mx-auto text-center md:max-w-[300px]"
                key={discount.sys.id}
              >
                <div
                  className="text-2xl font-bold"
                  data-testid="discount-title"
                >
                  {discount.fields.title}
                </div>
                {discount.fields.subtitle && (
                  <div className="mt-2" data-testid="discount-subtitle">
                    {discount.fields.subtitle}
                  </div>
                )}
                {discount.fields.cta && (
                  <UniversalCta className="mt-6" link={discount.fields.cta} />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Discounts);
